// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"633a8146","15":"c1868009","122":"4c4c717e","222":"5f934585","347":"1cba758c","510":"16ab4c25","513":"a3ad2944","550":"7c9acd20","673":"4f5138c3","945":"1edb024c"}[chunkId] + ".chunk.js";
};